// src/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

function AdminRoute({ children }) {
  // Retrieve admin user from localStorage
  const adminUser = JSON.parse(localStorage.getItem("adminUser"));

  // If there's no admin user or the admin flag is false, redirect to the admin login page.
  if (!adminUser || !adminUser.isAdmin) {
    return <Navigate to="/admin/login" />;
  }
  return children;
}

export default AdminRoute;